import React from 'react'
import i18tn from 'i18next'
import PropTypes from 'prop-types'
import {useAzubiList} from '#hooks/store/useAzubiList'
import Api from '#services/api'
import UploadFeedbackBaseModal from './UploadFeedbackBaseModal'

function UploadFeedbackAnAzubiModal({onSuccess}) {
  const {isLoading: isLoadingAzubis, allAzubis} = useAzubiList()

  const apiCallback = async (selectedFile, selectedOption) =>
    await Api.uploadFeedbackAnAzubi(selectedFile, selectedOption.value)

  const allAzubiOptions = allAzubis.map(azubi => ({
    value: azubi.id,
    label: azubi.name,
  }))

  return (
    <UploadFeedbackBaseModal
      apiCallback={apiCallback}
      onSuccess={onSuccess}
      isLoadingOptions={isLoadingAzubis}
      dropdownOptions={allAzubiOptions}
      dropdownPlaceholder={i18tn.t('upload_feedback_modal_an_azubi_dropdown_placeholder')}
      confirmDisabledReason={i18tn.t('upload_feedback_modal_an_azubi_confirm_button_disabled_reason')}
      uploadDescription={i18tn.t('upload_feedback_modal_an_azubi_description')}
    />
  )
}

UploadFeedbackAnAzubiModal.propTypes = {
  onSuccess: PropTypes.func,
}

export default UploadFeedbackAnAzubiModal
